import React, { useState, useEffect, useRef } from "react";
import style from "./Category.module.css";
import { BiSearch } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { MdArrowBack, MdChevronLeft, MdChevronRight, MdMoreVert } from "react-icons/md";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import Loader from "../Loder/Loader";
import { baseurl } from "../Url";

const Category = () => {
  const [popup, setPopup] = useState(false);
  const [category, setCategory] = useState(false);
  const [subCategory, setSubCategory] = useState(false);
  const [details, setDetails] = useState([]);
  const [subDetails, setSubDetails] = useState([]);
  const [goal, setGoal] = useState(false);
  const [goalDetail, setGoalDetail] = useState([]);
  const [topic, setTopic] = useState(false);
  const [topicDetail, setTopicDetail] = useState([]);
  const [goalSelection, setGoalSelection] = useState("");
  const [timeline, setTimeline] = useState("");
  const [comment, setComment] = useState("");
  const [profilePopup, setProfilePopup] = useState(false);
  const [aboutExp, setAboutExp] = useState("");
  const [yearExp, setYearExp] = useState("");
  const location = useLocation();
  const [search, setSearch] = useState(location.state?.keyword || "");
  const [sessionExpire, setSessionExpire] = useState(false);
  const [currentPath, setCurrentPath] = useState("Skills");
  const [loading, setLoading] = useState(true)
  const [subData, setSubData] = useState(false)
  const [subDetailsMap, setSubDetailsMap] = useState({});
  const [startPopup, setStartPopup] = useState(false);
  const [selectedLearning, setSelectedLearning] = useState(null);
  const [mappingLoading, setMappingLoading] = useState(false);
  const searchInputRef = useRef(null)
  const groupRefs = useRef({});
  const preferredCategoryOrder = ["AI", "Technology", "Gaming and Animation", "Healthcare"];

  const navigate = useNavigate()
  const outletCtx = useOutletContext()
  const onMenuToggle = outletCtx?.onMenuToggle
  const sidebarOpen = outletCtx?.sidebarOpen
  const key = JSON.parse(localStorage.getItem("access-token"));
  const lastSublevelId = localStorage.getItem("SubLevelId");
  const FirstId = localStorage.getItem("MainLevelId");
  const ClubID = localStorage.getItem("ClubID");
  const OrgID = localStorage.getItem("ORGID");

  const clubIdsArray = ClubID ? ClubID.split(",") : [];

  const getAuthToken = () => {
    const keyRaw = localStorage.getItem("access-token");
    let parsedToken = keyRaw;
    try {
      parsedToken = keyRaw ? JSON.parse(keyRaw) : null;
    } catch {
      parsedToken = keyRaw;
    }
    return parsedToken;
  };

  async function LearningsGet() {
    try {
      const res = await fetch(`${baseurl}/categories/type/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          org_id: OrgID,
          user_id: localStorage.getItem("USERID"),
        }),
      });

      const data = await res.json();
      console.log("Categories type list:", data);
      setLoading(false);

      if (!data?.status) {
        setDetails([]);
        setCategory(true);
        return;
      }

      const groups = Array.isArray(data.data) ? data.data : [];
      const normalized = [];

      groups.forEach((group, groupIndex) => {
        const categoryType = group.category_type || "";
        const courses = Array.isArray(group.courses) ? group.courses : [];

        courses.forEach((course, courseIndex) => {
          const name = course.course_name || "";
          const description = course.description || "";
          const image = course.thumbnail || "";
          // Prefer real backend IDs; avoid fabricated IDs which break downstream APIs.
          const id =
            course.category_id ||
            course.id ||
            course._id ||
            course.categoryID ||
            `${categoryType || "type"}-${groupIndex}-${courseIndex}`;

          normalized.push({
            ...course,
            Name: name,
            Description: description,
            category_id: id,
            category_image: image,
            course_categories: [],
            category_type: categoryType,
          });
        });
      });

      setDetails(normalized);
      setCategory(true);
    } catch (err) {
      console.error("Error fetching categories type list for /skills page:", err);
      setLoading(false);
      setDetails([]);
      setCategory(true);
    }
  }
  function getCategoryKey(learning) {
    const id = learning.category_id ?? learning.id ?? learning._id;
    if (id && typeof id === "object" && id.$oid) return id.$oid;
    return id != null ? String(id) : "";
  }

  const getPrimaryActionLabel = (subCategoryType) => {
    const rawValue = Array.isArray(subCategoryType)
      ? subCategoryType[0] || ""
      : subCategoryType || "";
    const normalizedValue = String(rawValue).toLowerCase();

    if (normalizedValue.includes("course") || normalizedValue.includes("skill")) {
      return "Master Skill";
    }
    if (
      normalizedValue.includes("internship") ||
      normalizedValue.includes("simulation")
    ) {
      return "Build Experience";
    }
    if (normalizedValue.includes("interview preparation")) {
      return "Get Ready";
    }
    if (normalizedValue.includes("exam preparation")) {
      return "Win Exam";
    }
    return "Start Learning";
  };

  async function subLearning(learning_id) {
    const id = learning_id != null ? String(learning_id) : "";
    if (!id) return;
    await fetch(`${baseurl}/sub/categories/get`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: OrgID,
        id: id,
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        const list = Array.isArray(data.data) ? data.data : data.data ? [data.data] : [];
        setSubDetailsMap((prev) => ({
          ...prev,
          [id]: list,
        }));
        if (data.category === true) setSubDetails(list);
        console.log(data);
      })
      .catch((err) => {
        setLoading(false);
        setSubDetailsMap((prev) => ({ ...prev, [id]: [] }));
        console.error(err);
      });
  }
  async function myGoal() {
    await fetch(`${baseurl}/goal/list`, {
      method: "POST",
      body: JSON.stringify({
        source: "web",
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setGoalDetail(data.data);

        console.log(data);
      });
  }
  async function Topic(e) {
    e.preventDefault()
    console.log("topic");
    await fetch(`${baseurl}/topic/get`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        category_id: subData === true ? FirstId : lastSublevelId,
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setTopicDetail(data.data);
        console.log(data);
      });
  }
  async function SaveLearning() {
    await fetch(`${baseurl}/userlearning/saving`, {
      method: "POST",
      body: JSON.stringify(saveData),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);

        if (data.status === true) {
          localStorage.setItem("userlerningid", data.data.userlearnings_id);
          setTopic(false);
          setPopup(false)
          navigate("/learnings")
          localStorage.removeItem("MainLevelId");
          localStorage.removeItem("SubLevelId");
        }
      });
  }

  async function learningValidation(e) {
    setProfilePopup(false);
    e.preventDefault();
    await fetch(
      `${baseurl}/profile/edit/learning/validation`,
      {
        method: "POST",
        body: JSON.stringify({
          year_of_exp: yearExp,
          about_exp: aboutExp,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          LearningsGet();
        }
        console.log(data);
      });
  }

  const saveData = {
    Organization_ID: OrgID,
    CourseName: currentPath,
    Goal: [
      {
        goal: goalSelection,
        time_line: timeline,
        comments: comment,
      },
    ],
    Topics: topicDetail,
    Categories: [
      {
        first_level: FirstId,
        last_level: subData === true ? FirstId : lastSublevelId,
      },
    ],
  };

  async function SearchApi() {
    await fetch(`${baseurl}/main/category/search`, {
      method: "POST",
      body: JSON.stringify({
        search: search,
        org_id: OrgID,
        club_id: clubIdsArray
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDetails(data.data);
      });
  }

  const fetchTopicsForCategory = async (categoryId, token) => {
    const res = await fetch(`${baseurl}/topic/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({
        org_id: OrgID,
        category_id: String(categoryId),
      }),
    });
    const data = await res.json();
    if (data?.status && Array.isArray(data.data)) {
      return data.data;
    }
    return [];
  };

  const mapProgramToUser = async (learningOverride = null) => {
    const learningToMap = learningOverride || selectedLearning;
    if (!learningToMap) return;

    const USERID = localStorage.getItem("USERID");
    const categoryId = getCategoryKey(learningToMap);
    const token = getAuthToken();
    const learningTitle =
      learningToMap?.Name || learningToMap?.course_name || "";

    if (!USERID || !OrgID || !categoryId) return;

    try {
      setMappingLoading(true);

      const topics = await fetchTopicsForCategory(categoryId, token);

      const saveRes = await fetch(`${baseurl}/skills/learning/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({
          Organization_ID: OrgID,
          CourseName: learningTitle,
          category_details: learningTitle,
          Goal: [
            {
              goal: "Skill Learning",
              time_line: "",
              comments: "",
            },
          ],
          Topics: Array.isArray(topics) ? topics : [],
          Categories: [
            {
              first_level: String(categoryId),
              last_level: String(categoryId),
            },
          ],
          club_id: clubIdsArray,
          user_id: USERID,
        }),
      });

      const saveData = await saveRes.json();
      let userLearningId =
        saveData?.data?.user_learning_id ||
        saveData?.data?.userlearning_id ||
        saveData?.user_learning_id ||
        saveData?.userlearning_id ||
        saveData?.data?.learnings_id ||
        saveData?.data?.learning_id ||
        null;

      if (!userLearningId && saveData?.data?.learning_id) {
        userLearningId = saveData.data.learning_id;
      }

      if (userLearningId) {
        localStorage.setItem("newLearningId", String(userLearningId));
        try {
          await fetch(`${baseurl}/skills/learning/get`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
            body: JSON.stringify({
              user_learning_id: String(userLearningId),
            }),
          });
        } catch (err) {
          console.error("Error calling /skills/learning/get", err);
        }
      } else {
        // If we couldn't get an id, the learning wasn't actually mapped → don't navigate.
        console.error("skills/learning/save did not return a learning id:", saveData);
        alert("Could not add this course to My Learnings. Please try again.");
        return;
      }

      // Persist that the user confirmed this course so we don't show the popup again
      try {
        localStorage.setItem(`course_start_confirmed_${String(categoryId)}`, "true");
      } catch {}

      setStartPopup(false);
      navigate("/lerning/detail", {
        state: {
          learning_detail: learningToMap,
          title: learningTitle,
          user_learning_id: userLearningId ? String(userLearningId) : undefined,
          returnPath: "/skills",
        },
      });
    } catch (err) {
      console.error("Error mapping program to user from /skills:", err);
    } finally {
      setMappingLoading(false);
    }
  };

  const handleCardClick = (learning) => {
    const name = learning?.Name || learning?.course_name || "";
    if (!name) return;
    setCurrentPath(name);
  };
  // useEffect(()=>{
  //   console.log(currentPath);
  // },[currentPath])

  useEffect(() => {
    if (search.length > 0) {
      SearchApi()
    }
    else {
      LearningsGet()
    }
  }, [search])
  useEffect(() => {
    LearningsGet();
  }, [key]);
  useEffect(() => {
    console.log(lastSublevelId);
  }, [lastSublevelId]);
  return (
    <div className={style.PageWrapper}>
      {loading ? <Loader /> : ''}
      {profilePopup ? (
        <>
          <div
            className={style.ProfileOverlay}
            onClick={() => {
              setProfilePopup(false);
              navigate("/learnings")
            }}
          ></div>
          <div className={style.AddressSection}>
            <form action="" onSubmit={learningValidation}>
              <div className={style.Formtext}>
                <p>Please enter experience details</p>
              </div>
              <input
                type="text"
                name=""
                id=""
                value={yearExp}
                required
                onChange={(e) => {
                  setYearExp(e.target.value);
                }}
                placeholder="Year Of experience"
              />
              <input
                type="text"
                name=""
                id=""
                value={aboutExp}
                required
                onChange={(e) => {
                  setAboutExp(e.target.value);
                }}
                placeholder="About experience"
              />

              <button type="submit">CONFIRM</button>
            </form>
          </div>
        </>
      ) : (
        ""
      )}

      <div className={style.topSection}>
        <div className={style.pageHeader}>
          {typeof onMenuToggle === "function" && (
            <button
              type="button"
              className={`${style.headerMenuBtn}${sidebarOpen ? ` ${style.headerMenuBtnSuppressed}` : ""}`}
              onClick={onMenuToggle}
              aria-label={sidebarOpen ? "Menu open" : "Open menu"}
              aria-expanded={sidebarOpen}
              tabIndex={sidebarOpen ? -1 : 0}
            >
            <MdMoreVert size={22} />
            </button>
          )}
          <button
            type="button"
            className={style.backBtn}
            onClick={() => navigate("/learnings")}
            aria-label="Back to My Learnings"
          >
            <MdArrowBack size={16} />
            <span>Back</span>
          </button>
          <div className={style.Head}>
            {/* <p className={style.label}>Search here</p> */}
            <div className={style.Input}>
              <BiSearch className={style.Icons} />
              <input
                ref={searchInputRef}
                onFocus={(e) => {
                  e.target.setAttribute("data-placeholder", e.target.placeholder);
                  e.target.placeholder = "";
                }}
                onBlur={(e) => {
                  e.target.placeholder = e.target.getAttribute("data-placeholder");
                }}
                placeholder="Search here"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={style.CategoryDiv}>

        <div
          className={style.Content}
          onClick={(e) => {
            if (e.target === e.currentTarget) searchInputRef.current?.focus();
          }}
        >
          <div className={style.Heading}>
            <p></p>
          </div>
          {category ? (
            <>
              {details && details.length > 0 ? (
                Object.entries(
                  details.reduce((grouped, item) => {
                    const type = item.category_type || "Other";
                    if (!grouped[type]) grouped[type] = [];
                    grouped[type].push(item);
                    return grouped;
                  }, {})
                )
                  .sort(([typeA], [typeB]) => {
                    const aIdx = preferredCategoryOrder.findIndex(
                      (name) => name.toLowerCase() === String(typeA).toLowerCase()
                    );
                    const bIdx = preferredCategoryOrder.findIndex(
                      (name) => name.toLowerCase() === String(typeB).toLowerCase()
                    );
                    const aRank = aIdx === -1 ? Number.MAX_SAFE_INTEGER : aIdx;
                    const bRank = bIdx === -1 ? Number.MAX_SAFE_INTEGER : bIdx;
                    if (aRank !== bRank) return aRank - bRank;
                    return String(typeA).localeCompare(String(typeB));
                  })
                  .map(([type, courses]) => (
                  <div key={type} className={style.CategoryGroup}>
                    <p className={style.CategoryLabel}>{type}</p>
                    <div className={style.CarouselShell}>
                      <button
                        type="button"
                        className={`${style.CarouselArrow} ${style.CarouselArrowLeft}`}
                        onClick={() => {
                          const node = groupRefs.current[type];
                          if (node) {
                            node.scrollBy({ left: -260, behavior: "smooth" });
                          }
                        }}
                        aria-label="Scroll left"
                      >
                        <MdChevronLeft size={18} />
                      </button>
                      <div
                        className={style.Grid}
                        ref={(el) => {
                          if (el) groupRefs.current[type] = el;
                        }}
                      >
                        {courses.map((learning) => {
                          const name = learning.Name || "";
                          const catKey = getCategoryKey(learning);
                          const blockedThumb =
                            "https://www.softwebsolutions.com/wp-content/uploads/2018/05/Machine-learning-models-1200x769.webp";
                          const defaultThumb =
                            "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=800";
                          const rawThumb =
                            (learning.category_image &&
                              learning.category_image.trim()) ||
                            "";
                          const imageSrc =
                            rawThumb && rawThumb !== blockedThumb ? rawThumb : defaultThumb;
                          const subs =
                            (learning.course_categories && learning.course_categories.length > 0)
                              ? learning.course_categories
                              : (subDetailsMap[catKey] || []);

                          const primaryActionLabel = getPrimaryActionLabel(
                            learning.sub_category_type
                          );

                          const subCategoryLabel = Array.isArray(learning.sub_category_type)
                            ? learning.sub_category_type.join(", ")
                            : (learning.sub_category_type || "");

                          return (
                            <div
                              key={catKey || name}
                              className={style.card}
                              onClick={() => handleCardClick(learning)}
                            >
                              <div
                                className={style.cardImageWrapper}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  subLearning(catKey);
                                }}
                              >
                                {imageSrc ? (
                                  <img
                                    src={imageSrc}
                                    alt={name}
                                    className={style.cardImage}
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                    }}
                                  />
                                ) : null}
                              </div>
                              <div
                                className={style.cardHeaderStrip}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  subLearning(catKey);
                                }}
                              >
                                <p className={style.cardTitle}>{name}</p>
                                {subCategoryLabel && (
                                  <p className={style.cardSubtitle}>{subCategoryLabel}</p>
                                )}
                              </div>
                              {subs.length > 0 ? (
                                <div
                                  className={style.subCategoryList}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {subs.map((sub) => {
                                    const subName =
                                      sub.Name ||
                                      sub.name ||
                                      sub.course_name ||
                                      sub.category_id ||
                                      "";
                                    const subImg =
                                      (sub.category_image &&
                                        sub.category_image.trim()) ||
                                      (sub.course_image &&
                                        sub.course_image.trim()) ||
                                      (sub.image && sub.image.trim()) ||
                                      "";
                                    return (
                                      <div
                                        key={sub.category_id || sub.id || subName}
                                        className={style.subCategoryCard}
                                      >
                                        <div className={style.subCategoryCardImage}>
                                          {subImg ? (
                                            <img
                                              src={subImg}
                                              alt={subName}
                                              onError={(e) => {
                                                e.currentTarget.style.display = "none";
                                              }}
                                            />
                                          ) : null}
                                        </div>
                                        <p className={style.subCategoryCardLabel}>
                                          {subName}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : null}

                              <div
                                className={style.cardActions}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <button
                                  type="button"
                                  className={style.primaryActionButton}
                                  onClick={() => {
                                    const catKey = getCategoryKey(learning);
                                    const confirmed =
                                      catKey &&
                                      localStorage.getItem(
                                        `course_start_confirmed_${String(catKey)}`
                                      ) === "true";

                                    setSelectedLearning(learning);
                                    // If user already confirmed for this course, skip the popup.
                                    if (confirmed) {
                                      mapProgramToUser(learning);
                                      return;
                                    }
                                    setStartPopup(true);
                                  }}
                                >
                                  {primaryActionLabel}
                                </button>
                                <button
                                  type="button"
                                  className={style.secondaryActionButton}
                                  onClick={() => {
                                    navigate("/skills/detail", {
                                      state: { learning_detail: learning, subs, title: name },
                                    });
                                  }}
                                >
                                  View Details
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <button
                        type="button"
                        className={`${style.CarouselArrow} ${style.CarouselArrowRight}`}
                        onClick={() => {
                          const node = groupRefs.current[type];
                          if (node) {
                            node.scrollBy({ left: 260, behavior: "smooth" });
                          }
                        }}
                        aria-label="Scroll right"
                      >
                        <MdChevronRight size={18} />
                      </button>
                    </div>
                  </div>
                ))
              ) : !search ? (
                <div className={style.NoData}>
                  <p>No categories available</p>
                </div>
              ) : (
                <div className={style.EmptyMessage}>
                  <p>No Matches Found</p>
                </div>
              )}
            </>
          ) : (
            ""
          )}
          
          {popup ? (
            <div className={style.Overlay}>
              <div className={style.POPUP}>
                {goal ? <div className={style.Goal}>
                  <div onClick={() => {
                    setGoal(false)
                    setPopup(false)
                      LearningsGet()
                    setSubCategory(false)
                    setCurrentPath("Skills")
                  }} className={style.Close}>
                    <AiOutlineClose />
                  </div>
                  <div className={style.goalHead}>
                    {/* <p> We can help you in achieving your goals and that you level up your skills:</p> */}
                    <p> Set your goal for {currentPath}</p>
                  </div>
                  <div className={style.GoalDiv}>
                    <div className={style.goalInput}>
                      <p>Goal<span className={style.Required}>*</span></p>
                      <select
                        name=""
                        id=""
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          console.log("Selected goal:", selectedValue);
                          setGoalSelection(selectedValue);
                        }}
                      >
                        {" "}
                        <option value="">Select a goal</option>
                        {goalDetail.length > 0 &&
                          goalDetail.map((goal) => {
                            return (
                              <option key={goal.GoalID} value={goal.GoalName}>
                                {goal.GoalName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <div className={style.goalInput}>
                      <p>Timeline<span className={style.Required}>*</span> </p>
                      <select
                        name=""
                        id=""
                        onChange={(e) => setTimeline(e.target.value)}
                      >
                        <option value="">Please Select a Month</option>
                        <option value="1">1 Month</option>
                        <option value="2">2 Month</option>
                        <option value="3">3 Month</option>
                        <option value="4">4 Month</option>
                        <option value="5">5 Month</option>
                        <option value="6">6 Month</option>
                        <option value="7">7 Month</option>
                        <option value="8">8 Month</option>
                        <option value="9">9 Month</option>
                        <option value="10">10 Month</option>
                        <option value="11">11 Month</option>
                        <option value="12">12 Month</option>
                      </select>
                    </div>
                    <div className={style.CommentInput}>
                      <p >Comment </p>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="5"
                        onChange={(e) => setComment(e.target.value)}
                      ></textarea>
                    </div>
                    {/* <div className={style.checkbox}>
                        <label className={style.mainLabel}>Please set your preferences of learning</label>
                        <div className={style.checkboxGroup1}>
                         <input type="checkbox" id="checkbox1" />
                         <label htmlFor="checkbox1">Need Individual Training</label><br/>
    
                           <input type="checkbox" id="checkbox2" />
                           <label htmlFor="checkbox2">Self Reading of Lessons</label><br/>
    
                          <input type="checkbox" id="checkbox3" />
                           <label htmlFor="checkbox3">Watching Training videos</label><br/>
    
                            <input type="checkbox" id="checkbox4" />
                           <label htmlFor="checkbox4">Offline Training</label><br/>
    
                         <input type="checkbox" id="checkbox5" />
                         <label htmlFor="checkbox5">Online Training</label><br/>
    
                         <input type="checkbox" id="checkbox6" />
                          <label htmlFor="checkbox6">Hybrid Training(Online&Offline)</label>
                         </div>
                      </div> */}
                    {/* <div className={style.checkbox}>
                      <label className={style.mainLabel}>Would you like to get individual training sessions ?</label>
                      <div className={style.checkboxGroup1}>
                      <input type="radio" id="checkbox1" />
                         <label htmlFor="checkbox1">Yes</label>
    
                           <input type="radio" id="checkbox2" />
                           <label htmlFor="checkbox2">No</label>
                      </div>
                      </div> */}
                    {/* <div className={style.checkbox}>
                      <label className={style.mainLabel}>Would you like to get more assessments ?</label>
                      <div className={style.checkboxGroup1}>
                      <input type="radio" id="checkbox1" />
                         <label htmlFor="checkbox1">Yes</label>
    
                           <input type="radio" id="checkbox2" />
                           <label htmlFor="checkbox2">No</label>
                      </div>
                      </div>
                      <div className={style.checkbox}>
                      <label className={style.mainLabel}>Would you like to practice the lessons ?</label>
                      <div className={style.checkboxGroup1}>
                      <input type="radio" id="checkbox1" />
                         <label htmlFor="checkbox1">Yes</label>
    
                           <input type="radio" id="checkbox2" />
                           <label htmlFor="checkbox2">No</label>
                      </div>
                      </div>
                      <div className={style.checkbox}>
                      <label className={style.mainLabel}>Do you want Peers (Other learners) with with you? </label>
                      <div className={style.checkboxGroup1}>
                      <input type="radio" id="checkbox1" />
                         <label htmlFor="checkbox1">Yes</label>
    
                           <input type="radio" id="checkbox2" />
                           <label htmlFor="checkbox2">No</label>
                      </div>
                      </div> */}

                    <div className={style.goalButton}>
                      <button
                        onClick={(e) => {
                          Topic(e);
                          setGoal(false);
                          setTopic(true);
                        }}
                        disabled={
                          timeline === "" ||
                          goalSelection === ""
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>

                  : ""}
                {topic ?
                  <div className={style.topic}>
                    <div onClick={() => {
                      setTopic(false)
                      setPopup(false)
                      LearningsGet()
                      setSubCategory(false)
                      setCurrentPath("Skills")
                    }} className={style.Close}>
                      <AiOutlineClose />
                    </div>
                    <div className={style.topicHead}>
                      <h4>Subject-{currentPath}</h4>
                    </div>
                    <div className={style.Topicdiv}>
                      <div className={style.topicDetails}>
                        {topicDetail.length > 0 &&
                          topicDetail[0].topics.map((topic) => {
                            return <p> {topic.value}</p>;
                          })}
                      </div>
                      <div className={style.learningButton}>
                        <button
                          onClick={() => {
                            SaveLearning();
                            // setTopic(false);
                            // setPopup(false)
                          }}
                        >
                          Start Learning
                        </button>
                      </div>
                    </div>
                  </div>
                  : ''

                }
              </div>
            </div>
          ) : (
            ""
          )}

          {startPopup && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={() => {
                if (!mappingLoading) {
                  setStartPopup(false);
                  setSelectedLearning(null);
                }
              }}
            >
              <div
                style={{
                  width: "min(460px, 92vw)",
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "24px",
                  boxShadow: "0 20px 45px rgba(15, 23, 42, 0.2)",
                  border: "1px solid #e2e8f0",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    lineHeight: 1.35,
                    textAlign: "center",
                    fontWeight: 600,
                    color: "#1e293b",
                  }}
                >
                  Do you want to start learning
                </p>
                <p
                  style={{
                    margin: "6px 0 0 0",
                    fontSize: "20px",
                    lineHeight: 1.35,
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#1e293b",
                  }}
                >
                  {selectedLearning?.Name ||
                    selectedLearning?.course_name ||
                    "this skill"}
                  {" ?"}
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginTop: "22px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      // User declined; store for analytics/debug if needed (doesn't suppress future popups)
                      try {
                        const categoryId = getCategoryKey(selectedLearning);
                        if (categoryId) {
                          localStorage.setItem(`course_start_declined_${String(categoryId)}`, "true");
                        }
                      } catch {}
                      setStartPopup(false);
                      setSelectedLearning(null);
                    }}
                    disabled={mappingLoading}
                    style={{
                      flex: 1,
                      height: "46px",
                      borderRadius: "10px",
                      border: "1px solid #cbd5e1",
                      background: "#fff",
                      color: "#0f172a",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    onClick={() => mapProgramToUser(selectedLearning)}
                    disabled={mappingLoading}
                    style={{
                      flex: 1,
                      height: "46px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#0151CD",
                      color: "#fff",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    {mappingLoading ? "Please wait..." : "Yes"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

      </div >    </div>
  );
};

export default Category;
